<template>
  <add-edit-dialog>
    <crm-panel title="新增合同">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          :disabled="isSubmitDisabled"
          :loading="loading"
          @click="handleSave()"
        >
        </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleClose()">
        </crm-button>
      </div>
      <el-form
        label-position="right"
        label-width="150px"
        :rules="rules"
        ref="form"
        :model="form"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item
              label="合同类型："
              prop="contractType"
              :rules="{
                required: true,
                message: '请选择合同类型',
                trigger: 'change',
              }"
            >
              <el-select
                clearable
                v-model="form.contractType"
                @change="handleContractTypeChange"
              >
                <el-option
                  v-for="item in compactType"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3" v-if="contractModule !== 1">
            <cusname-select
              v-if="contractModule && !customId"
              :val="form.customerId"
              :customSelectData="customSelectData"
              :customSelectSearch="customSelectSearch"
              @change="handleCusNameChange"
            >
            </cusname-select>
            <el-form-item
              v-if="contractModule && customId"
              label="客户名称："
              prop="customName"
              :rules="{ required: true }"
            >
              <el-input v-model="form.customName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="contractModule !== 1" :span="8">
            <el-form-item label="业务员：" prop="salesmanCode" v-if="contractModule">
              <el-select
                @change="salesSelected"
                clearable
                v-model="form.salesmanCode"
                :disabled="Boolean(detail && detail.form === 'busi')"
              >
                <el-option
                  :key="item.salesmanCode"
                  v-for="item in customSalesman"
                  :label="item.salesmanName"
                  :value="item.salesmanCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="contractModule === 1">
          <el-row>
            <el-col :span="8" :offset="3">
              <cusname-select
                :customSelectSearch="customSelectSearch"
                :customSelectData="customSelectData"
                v-if="contractModule && !customId"
                :val="form.customerId"
                @change="handleCusNameChange"
              >
              </cusname-select>
              <el-form-item
                v-if="contractModule && customId"
                label="客户名称："
                prop="customName"
                :rules="{ required: true }"
              >
                <el-input v-model="form.customName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业务员：" prop="salesmanCode" v-if="contractModule">
                <el-select
                  clearable
                  :disabled="Boolean(detail && detail.form === 'busi')"
                  v-model="form.salesmanCode"
                  @change="handleSalesmanChange"
                >
                  <el-option
                    :key="item.salesmanCode"
                    v-for="item in customSalesman"
                    :label="item.salesmanName"
                    :value="item.salesmanCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input v-model="form.contractNo" name="contractNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联商机：">
                <el-select
                  :disabled="Boolean(detail && detail.form === 'busi')"
                  clearable
                  filterable
                  remote
                  placeholder="请选择商机名称"
                  @focus="handleBusiSelectFocus"
                  @change="handleBusiSelectChange"
                  @clear="handleBusiSelectClear"
                  :remote-method="handleBusiSearch"
                  :loading="selectBusiData.loading"
                  :value="searchBusi"
                >
                  <el-option
                    v-for="item in selectBusiList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                    ><el-tooltip
                      v-if="item.name.length > 40"
                      class="item custom-select-item"
                      effect="dark"
                      :content="item.name"
                      placement="top"
                    >
                      <span>{{ item.name }}</span>
                    </el-tooltip>
                    <span v-else>{{ item.name }}</span>
                  </el-option>
                  <el-option
                    v-if="
                      busiSelectData.totalCount > selectBusiData.pageSize &&
                      selectBusiData.pageIndex < busiSelectData.totalPages
                    "
                    label="点击加载更多"
                    value="点击加载更多"
                    :disabled="true"
                    style="cursor: pointer"
                  >
                    <span @click="handleMoreBusiList()">点击加载更多</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="产品线：" prop="businessLine">
                <el-cascader
                  ref="cascader"
                  :show-all-levels="false"
                  :options="allProductLine"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'productLineList',
                    emitPath: false,
                    multiple: true,
                  }"
                  clearable
                  placeholder="请选择"
                  v-model="form.businessLine"
                  @change="handleChange"
                >
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合作模式：" prop="coopMode">
                <el-select clearable v-model="form.coopMode">
                  <el-option
                    :key="item.uid"
                    v-for="item in modeTypeList"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="签约形式：" prop="signingForm">
                <el-select
                  placeholder="请选择签约形式"
                  clearable
                  v-model="form.signingForm"
                >
                  <el-option
                    v-for="item in signingForm"
                    :label="item.name"
                    :value="item.uid"
                    :key="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签订日期：" class="date-add-return" prop="signDate">
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.signDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item
                label="合同金额(元)："
                prop="contractAmountStr"
                :rules="[
                  {
                    pattern: /^\d+(\.\d{0,2})*$/,
                    message: '请输入最多两位小数数字',
                    trigger: 'blur',
                  },
                  { min: 0, max: 12, message: '最多9个数字', trigger: 'blur' },
                ]"
              >
                <el-input
                  v-model="form.contractAmountStr"
                  name="contractAmountStr"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结算方式：" prop="settlementType">
                <el-select clearable v-model="form.settlementType">
                  <el-option
                    v-for="item in settlementType"
                    :label="item.name"
                    :value="item.uid"
                    :key="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="contractModule === 2">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input v-model="form.contractNo" name="contractNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签订日期：" class="date-add-return" prop="signDate">
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.signDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合作科室：" prop="departmentIds">
                <el-select clearable v-model="form.departmentIds" multiple>
                  <el-option
                    :key="item.uid"
                    v-for="item in coprationDepartment"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="合同金额(元)："
                prop="contractAmountStr"
                :rules="[
                  {
                    required: true,
                    message: '请输入合同金额',
                    trigger: 'blur',
                  },
                  {
                    pattern: /^\d+(\.\d{0,2})*$/,
                    message: '请输入最多两位小数数字',
                    trigger: 'blur',
                  },
                  { min: 0, max: 12, message: '最多9个数字', trigger: 'blur' },
                ]"
              >
                <el-input
                  v-model="form.contractAmountStr"
                  name="contractAmountStr"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="contractModule === 3">
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input v-model="form.contractNo" name="contractNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签订日期：" class="date-add-return" prop="signDate">
                <el-date-picker
                  :editable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.signDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="合作科室：" prop="departmentIds">
                <el-select clearable v-model="form.departmentIds" multiple>
                  <el-option
                    :key="item.uid"
                    v-for="item in coprationDepartment"
                    :label="item.name"
                    :value="item.uid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科室综合收入比例：" prop="incomeRatio">
                <el-input v-model="form.incomeRatio"></el-input>
                <span style="position: absolute; top: 0px; right: 10px">%</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item
                label="合同金额(元)："
                prop="totalContractMoneyCopy"
                :rules="{ required: true, message: '', trigger: 'change' }"
              >
                <el-input :value="form.totalContractMoneyCopy" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="岗前培训费(元)：" prop="preJobTrainingStr">
                <el-input v-model="form.preJobTrainingStr"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="驻点带教费(元)：" prop="residentTeachStr">
                <el-input v-model="form.residentTeachStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="定期带教费(元)：" prop="regularTeachStr">
                <el-input v-model="form.regularTeachStr"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="多点执业费(元)：" prop="multipointPracticeStr">
                <el-input v-model="form.multipointPracticeStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="运营启动费(元)：" prop="operateStartedStr">
                <el-input v-model="form.operateStartedStr"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="运营运维费(元)：" prop="operateOperationStr">
                <el-input v-model="form.operateOperationStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="contractModule">
          <el-col :span="8" :offset="3">
            <el-form-item label="合同开始日期：" prop="startDate">
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="form.startDate"
                name="startDate"
                type="date"
                :picker-options="startDateLimit"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同结束日期：" prop="endDate">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="form.endDate"
                name="endDate"
                type="date"
                :picker-options="endDateLimit"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="contractModule">
          <el-col :span="16" :offset="3">
            <el-form-item label="备注：" prop="remarks">
              <el-input
                type="textarea"
                placeholder="不超过200字"
                :rows="4"
                v-model="form.remarks"
                name="remarks"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="contractModule">
          <el-form-item label="上传附件：">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="action"
              :http-request="handleUpdate"
              :before-upload="beforeAvatarUpload"
              :on-success="handleOnSuccess"
              :on-error="handleOnError"
              :file-list="uploadList"
              :before-remove="beforeRemove"
            >
              <crm-button :text="'上传'"></crm-button>
            </el-upload>
          </el-form-item>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import { uploadFileVerify } from "@/scripts/reg";

import crmButton from "@/components/base/crmButton";
import crmPanel from "@/components/base/crmPanel";
import AddEditDialog from "@/components/base/addEditDialog";
import CusnameSelect from "@/components/business/custom/cusname-select";
import service from "@/services/api/compact";

export default {
  components: {
    crmButton,
    crmPanel,
    AddEditDialog,
    CusnameSelect,
  },
  props: {
    customId: {
      type: String,
    },
    customName: {
      type: String,
    },
    detail: Object,
  },
  data() {
    const incomeRatioRule = (rule, value, callback) => {
      if (!/^100$|^(\d|[1-9]\d)(\.\d{0,2})*$/.test(value) && value !== "100.00") {
        callback(new Error("请输入最多两位小数0-100的数字"));
      } else {
        callback();
      }
    };
    const moneyRule = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数且无逗号的数字"));
      } else if (value > 99999999.99) {
        callback(new Error("最大99999999.99"));
      } else {
        callback();
      }
    };
    return {
      startDateLimit: {
        disabledDate: (time) => {
          if (!this.form.endDate) return false;
          return time.getTime() >= new Date(this.form.endDate).getTime();
        },
      },
      endDateLimit: {
        disabledDate: (time) => {
          if (!this.form.startDate) return false;
          return (
            time.getTime() <=
            new Date(this.form.startDate).getTime() - 1 * 24 * 3600 * 1000
          );
        },
      },
      // 合同模板
      contractModule: null,
      form: {
        contractType: null,
      },
      rules: {
        contractType: [{ required: true, message: "请选择合同类型", trigger: "change" }],
        salesmanCode: [{ required: true, message: "请选择业务员", trigger: "change" }],
        customerId: [{ required: true, message: "请选择客户名称", trigger: "change" }],
        contractNo: [
          { required: true, message: "请填写合同编号", trigger: "blur" },
          { max: 50, message: "不超过50个字", trigger: "blur" },
        ],
        signingForm: [{ required: true, message: "请选择签约形式", trigger: "change" }],
        signDate: [{ required: true, message: "请选择签订日期", trigger: "change" }],
        businessLine: [{ required: true, message: "请选择产品线", trigger: "change" }],
        remarks: [{ max: 200, message: "不超过200个字", trigger: "blur" }],
        departmentIds: [{ required: true, message: "请选择合作科室", trigger: "change" }],
        startDate: [{ required: true, message: "请选择合同开始日期", trigger: "change" }],
        endDate: [{ required: true, message: "请选择合同结束日期", trigger: "change" }],
        incomeRatio: [
          {
            required: true,
            message: "请填写科室综合收入比例",
            trigger: "blur",
          },
          { validator: incomeRatioRule, trigger: "blur" },
        ],
        preJobTrainingStr: [
          { required: true, message: "请填写岗前培训费", trigger: "blur" },
          { validator: moneyRule, trigger: "blur" },
        ],
        residentTeachStr: [
          { required: true, message: "请填写驻点带教费", trigger: "blur" },
          { validator: moneyRule, trigger: "blur" },
        ],
        regularTeachStr: [
          { required: true, message: "请填写定期带教费", trigger: "blur" },
          { validator: moneyRule, trigger: "blur" },
        ],
        multipointPracticeStr: [
          { required: true, message: "请填写多点执业费", trigger: "blur" },
          { validator: moneyRule, trigger: "blur" },
        ],
        operateStartedStr: [
          { required: true, message: "请填写运营启动费", trigger: "blur" },
          { validator: moneyRule, trigger: "blur" },
        ],
        operateOperationStr: [
          { required: true, message: "请填写运营运维费", trigger: "blur" },
          { validator: moneyRule, trigger: "blur" },
        ],
      },
      // 业务员下拉框
      customSalesman: [],
      // 商机下拉列表
      selectBusiData: {
        loading: false,
        query: "",
        pageIndex: 1,
        pageSize: 50,
      },
      busiSearchCustomId: "",
      // 用来搜索商机的客户id
      customSelectSearchUid: "",
      selectBusiList: [],
      uploadList: [],
      isSubmitDisabled: false,
      allProductLine: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      compactType: "compact/compactType",
      customSelectData: "compact/customSelectData",
      busiSelectData: "compact/busiSelectData",
      settlementType: "compact/settlementType",
      busiLineList: "business/busiLineList",
      coprationDepartment: "compact/coprationDepartment",
      signingForm: "compact/signingForm",
      compactSalesman: "compact/compactSalesman",
      modeTypeList: "common/modeTypeList",
      userInfo: "authority/userInfo",
    }),
    // 避免商机下拉框点击更多数据时搜索关键字消失
    searchBusi() {
      return this.form.businessId || this.selectBusiData.query;
    },
    totalContractMoney() {
      return (
        (this.form.preJobTrainingStr * 100 +
          this.form.residentTeachStr * 100 +
          this.form.regularTeachStr * 100 +
          this.form.multipointPracticeStr * 100 +
          this.form.operateStartedStr * 100 +
          this.form.operateOperationStr * 100) /
        100
      );
    },
  },
  watch: {
    totalContractMoney(val) {
      this.form.totalContractMoneyCopy = val;
    },
    compactSalesman(val) {
      this.customSalesman = val;
    },
  },
  created() {
    this.form.contractType = "";
    console.log(this.customId, "customId");
    console.log(this.detail, "detail");

    if (this.customId) {
      this.customSelectSearchUid = this.customId;
      this.busiSearchCustomId = this.customId;
      this.handleGetSalesman({ customerUid: this.customId }).then(() => {
        this.getBusiSelectList();
      });
    }
    // 获取合同类型
    if (this.compactType.length === 0) {
      this.getCompactTypeList({
        pageNumber: 1,
        pageSize: 100,
        code: "category_contract_type",
      });
    }
    // 获取产品线
    this.getAllProductLine();

    // 获取合作模式
    if (this.modeTypeList.length === 0) {
      this.getModeType({
        pageNumber: 1,
        pageSize: 100,
        code: "category_mode_type",
      });
    }
    // 获取结算方式
    if (this.settlementType.length === 0) {
      this.getSettlementTypeList({
        pageNumber: 1,
        pageSize: 100,
        code: "category_settlement_type",
      });
    }
    // 获取合作科室
    if (this.coprationDepartment.length === 0) {
      this.getCoprationDepartmentList({
        pageNumber: 1,
        pageSize: 100,
        code: "category_department",
      });
    }
    // 获取签约形式
    if (this.signingForm.length === 0) {
      this.getSigningFormList({
        pageNumber: 1,
        pageSize: 100,
        code: "category_signing_form",
      });
    }
  },
  methods: {
    ...mapActions({
      customSelectSearch: "compact/customSelectSearch",
      getCompactTypeList: "compact/getCompactTypeList",
      busiSelectSearch: "compact/busiSelectSearch",
      getBusiLineList: "business/getBusiLineList",
      getSettlementTypeList: "compact/getSettlementTypeList",
      uploadCompactFile: "compact/uploadCompactFile",
      saveAddCompact: "compact/saveAddCompact",
      getCoprationDepartmentList: "compact/getCoprationDepartmentList",
      getSigningFormList: "compact/getSigningFormList",
      getCompactSalesman: "compact/getCompactSalesman",
      getModeType: "common/getModeType",
    }),
    // 选择合同类型，使用不同合同模板
    handleContractTypeChange(val) {
      this.$refs.form.clearValidate();
      if (
        val === "21cbef6460f249f1ba39716e60922117" ||
        val === "cbb006bf8d35416fb6cd28442c570f38"
      ) {
        // this.rules = this.rules2;
        this.contractModule = 2;
        this.form = {
          contractType: val,
          salesmanCode: null,
          customerId: null,
          contractNo: null,
          signDate: null,
          contractAmountStr: null,
          departmentIds: [],
          startDate: null,
          endDate: null,
          remarks: null,
          files: [],
        };
      } else if (val === "8629ff61554941f282146ce6cbba3856") {
        // this.rules = this.rules3;
        this.contractModule = 3;
        this.form = {
          contractType: val,
          salesmanCode: null,
          customerId: null,
          contractNo: null,
          signDate: null,
          contractAmountStr: null,
          totalContractMoneyCopy: 0,
          departmentIds: [],
          incomeRatio: null,
          preJobTrainingStr: null,
          residentTeachStr: null,
          regularTeachStr: null,
          multipointPracticeStr: null,
          operateStartedStr: null,
          operateOperationStr: null,
          startDate: null,
          endDate: null,
          remarks: null,
          files: [],
        };
      } else {
        // this.rules = this.rules1;
        this.contractModule = 1;
        this.form = {
          contractType: val,
          salesmanCode: null,
          signingForm: null,
          customerId: null,
          contractNo: null,
          businessId: null,
          signDate: null,
          businessLine: null,
          contractAmountStr: null,
          settlementType: null,
          startDate: null,
          endDate: null,
          remarks: null,
          files: [],
        };
      }
      if (this.customName) this.form.customName = this.customName;
      if (this.customId) this.form.customerId = this.customId;
      if (this.detail) {
        this.form.customName = this.detail.customName;
        const salesmanCodeList = this.detail.salesmanCode.split(",");
        try {
          this.form.salesmanCode = salesmanCodeList[0];
        } catch (e) {
          this.form.salesmanCode = "";
        }
        this.form.businessLine = [];
        this.detail.productLineList.forEach((i) => {
          this.form.businessLine.push(i.businessLine);
        });
        this.form.businessId = this.detail.id;
      }

      // this.$nextTick(() => {
      // this.form.contractType = val;
      // });
    },
    handleSalesmanChange() {
      this.selectBusiList = [];
      this.form.businessId = "";
    },
    handleClose() {
      this.$emit("close");
    },
    // 展示的文件列表中删除文件，将传给后端的文件id删除
    beforeRemove(file) {
      const delIndex = this.uploadList.findIndex((item) => item.url === file.url);
      if (delIndex !== -1) {
        this.form.files.splice(delIndex, 1);
      }
      return true;
    },
    handleOnError() {},
    // 文件上传前文件大小拦截
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return Promise.reject();
      }
      /* eslint-disable */
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 文件上传成功时同步文件列表
    handleOnSuccess(response, file, fileList) {
      this.uploadList = fileList;
    },
    // 文件上传
    handleUpdate(item) {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在上传中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append("file", item.file);
      params.append("fileName", item.file.name);
      this.uploadCompactFile({
        params,
        config: { "Content-Type": "multipart/form-data", timeout: 100000 },
      })
        .then((res) => {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          item.onSuccess();
          this.form.files.push(res.data.data);
        })
        .catch(() => {
          item.onError();
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    // 新增
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.isSubmitDisabled = true;
          if (this.contractModule === 3) {
            this.form.contractAmountStr = this.totalContractMoney;
          }
          const params = {};
          Object.keys(this.form).forEach((item) => {
            if (this.form[item]) {
              params[item] = this.form[item];
            }
          });
          this.saveAddCompact({
            ...params,
            businessLineList: this.form.businessLine,
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "新增合同成功",
              });
              this.$emit("close");
              this.$emit("success");
              this.loading = false;
            })
            .finally(() => {
              this.isSubmitDisabled = false;
            });
        }
      });
    },
    // 客户下拉框 数据变更时清空商机的id，重新给用于商机搜索的客户id赋值，没有值时清除商机下拉列表
    handleCusNameChange(value) {
      // 选择客户后，访问业务员接口
      if (value) {
        const customerUid = {
          customerUid: value,
        };
        this.handleGetSalesman(customerUid);
      }
      this.form.businessId = "";
      if (!value) {
        this.selectBusiList = [];
        this.form.salesmanCode = "";
        this.customSalesman = [];
      }
      this.busiSearchCustomId = value;
      this.form.customerId = value;
    },
    handleGetSalesman(customerUid) {
      return this.getCompactSalesman(customerUid).then(() => {
        if (this?.detail?.salesmanCode) {
          this.form.salesmanCode = this.detail.salesmanCode;
          return;
        } else {
          if (this.compactSalesman.length) {
            this.form.salesmanCode = this.compactSalesman[0].salesmanCode;
          }
        }
      });
    },
    // 选择业务员后，更新联系人列表，
    salesSelected(value) {
      this.form.salesmanCode = this.value;
    },
    // 商机下拉框 聚焦时请求数据
    handleBusiSelectFocus() {
      // if (this.form.businessId) return;
      this.selectBusiData.pageIndex = 1;
      this.selectBusiData.query = "";
      this.getBusiSelectList();
    },
    handleBusiSelectChange(value) {
      this.form.businessId = value;
    },
    handleBusiSelectClear() {
      this.selectBusiData.query = "";
    },
    handleBusiSearch(query) {
      this.selectBusiData.query = query;
      this.selectBusiData.pageIndex = 1;
      this.getBusiSelectList();
    },
    getBusiSelectList() {
      return new Promise((resolve, reject) => {
        if (!this.form.salesmanCode || !this.busiSearchCustomId) {
          this.$message.info("请先选择客户及业务员");
          return;
        }
        this.busiSelectSearch({
          customerId: this.busiSearchCustomId,
          salesmanCode: this.form.salesmanCode,
          uid: this.busiSelectSearchUid,
          name: this.selectBusiData.query,
          pageSize: this.selectBusiData.pageSize,
          pageNumber: this.selectBusiData.pageIndex,
        })
          .then(() => {
            this.busiSelectSearchUid = "";
            if (this.selectBusiData.pageIndex === 1) {
              this.selectBusiList = [];
            }
            this.busiSelectData.results.forEach((item) => {
              this.selectBusiList.push(item);
            });
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleMoreBusiList() {
      this.isBusiMore = true;
      this.selectBusiData.pageIndex += 1;
      this.getBusiSelectList();
    },
    // 产品线
    handleChange() {
      // const checkedNodes = this.$refs['cascader'].getCheckedNodes();
      // this.form.businessLineName = checkedNodes[0].label;
    },
    getAllProductLine() {
      service.queryProductLineList().then((res) => {
        console.log(res.data, "getAllProductLine");
        res.data.data.forEach((item) => {
          this.allProductLine.push({
            ...item,
            id: item.typeCode,
            name: item.typeName,
          });
        });
      });
    },
  },
};
</script>

<style lang="less">
.addcompact-container {
  padding-right: 30px;
  .dialog-footer {
    text-align: right;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
